module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 0 0",
      "height": "100%"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_vm._l((_vm.row.member_list), function(member, index) {
    return _c('div', {
      key: index
    }, [_c('van-cell-group', [_c('van-cell', {
      attrs: {
        "readonly": "",
        "input-align": "right",
        "title": '人员' + (index + 1),
        "label": member.num,
        "value": member.name
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "现有裁判等级",
        "value": member.caipandengji,
        "input-align": "right"
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "现有教练等级",
        "value": member.jiaoliandengji,
        "input-align": "right"
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "高等级证书",
        "value": _vm.row.grade_pics.length + '/6'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('PicUploader', {
      attrs: {
        "fileList": _vm.row.grade_pics,
        "limit": 6,
        "name": 'heying'
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "operate-desc-left"
    }, [_vm._v("（选填）如果系统识别等级有误，请上传您的最高等级证书")])], 1), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
      attrs: {
        "is-link": member.peixunshioptions.length > 0,
        "title": "培训师等级申报",
        "value": member.peixunshishenbao,
        "label": '现有等级 ' + (member.peixunshi ? member.peixunshi : '无'),
        "input-align": "right"
      },
      on: {
        "click": function($event) {
          _vm.thisMemberIndex = index;
          _vm.thisMemberField = 'peixunshishenbao';
          _vm.shenbaoTypeColumns = member.peixunshioptions;
          _vm.showShenbaoTypePicker = true
        }
      }
    }), _vm._v(" "), _c('van-cell', {
      attrs: {
        "is-link": member.kaoguanoptions.length > 0,
        "title": "考官等级申报",
        "value": member.kaoguanshenbao,
        "label": '现有等级 ' + (member.kaoguan ? member.kaoguan : '无'),
        "input-align": "right"
      },
      on: {
        "click": function($event) {
          _vm.thisMemberIndex = index;
          _vm.thisMemberField = 'kaoguanshenbao';
          _vm.shenbaoTypeColumns = member.kaoguanoptions;
          _vm.showShenbaoTypePicker = true
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "20px",
        "font-size": "14px",
        "color": "#444",
        "line-height": "30px"
      }
    }, [_c('p', {
      staticStyle: {
        "text-align": "center",
        "font-weight": "bold"
      }
    }, [_vm._v("申报标准说明")]), _vm._v(" "), _c('p', [_vm._v("三级教练员/无教练员可申报初级培训师")]), _vm._v(" "), _c('p', [_vm._v("二级教练员——中级培训师")]), _vm._v(" "), _c('p', [_vm._v("一级教练员——高级培训师")]), _vm._v(" "), _c('p', [_vm._v("三级裁判员/无裁判员——初级考官")]), _vm._v(" "), _c('p', [_vm._v("二级裁判员——中级考官")]), _vm._v(" "), _c('p', [_vm._v("一级裁判员——高级考官")]), _vm._v(" "), _c('p', [_vm._v("国家级裁判员——高级培训师、高级考官、监督或")])])], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goPre()
      }
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 2), _vm._v(" "), (_vm.shenbaoTypeColumns.length > 0) ? _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showShenbaoTypePicker),
      callback: function($$v) {
        _vm.showShenbaoTypePicker = $$v
      },
      expression: "showShenbaoTypePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.shenbaoTypeColumns,
      "show-toolbar": "",
      "default-index": 0
    },
    on: {
      "cancel": function($event) {
        _vm.showShenbaoTypePicker = false
      },
      "confirm": _vm.onShenbaoTypeConfirm
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e0ccc5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiApplyFormStep31.vue
// module id = 2382
// module chunks = 0